import React from 'react';
import { Container, Box } from '@mui/material';
import RegistrationForm from './RegistrationForm';

const App = () => {
  return (
    <Box>
      <Container maxWidth="md" sx={{ py: 5 }}>
        <Box id="registration">
          <RegistrationForm />
        </Box>
      </Container>
    </Box>
  );
};

export default App;